import { ReactNode, useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
} from "react-router-dom";

const TitledRoutes = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const matches = matchRoutes(createRoutesFromChildren(children), location);
  const pageTitle = matches
    ?.slice()
    .reverse()
    .find((match) => match.route.handle?.title)?.route.handle.title;
  const title = pageTitle ? `${pageTitle} | C1 Hub` : "C1 Hub";

  useEffect(() => {
    document.title = title;
  }, [title]);

  return <Routes>{children}</Routes>;
};

export default TitledRoutes;
